import React from 'react'
import Box from '@src/components/Box'

interface PageHeaderProps {
  label: any
}
const PageHeader: React.FC<PageHeaderProps> = ({ label }) => (
  <Box
    component="h1"
    fontSize={32}
    fontWeight="fontWeightBold"
    letterSpacing={-0.5}
    mt={3}
    mb={3}
  >
    {label}
  </Box>
)

export default PageHeader
